<template>
  <div>
    <el-descriptions>
      <el-descriptions-item
        :label="$l('INDEX.table_label_customer_name') || '客户名称'"
        >{{ formData.custName }}</el-descriptions-item
      >
      <el-descriptions-item
        :label="$l('INDEX.table_label_endcustomer_name') || '终端客户名称'"
        >{{ formData.endCustName }}</el-descriptions-item
      >
    </el-descriptions>
    <el-form size="mini" :rules="rules" ref="form" :model="formData">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_batch_label_shipmentStartDate') || '客户最早交期'"
            prop="plannedETD"
          >
            <el-date-picker
              v-model="formData.plannedETD"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_batch_label_shipmentEndDate') || '客户最晚交期'"
            prop="plannedEndETD"
          >
            <el-date-picker
              v-model="formData.plannedEndETD"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
            prop="cargoReadyDay"
          >
            <el-date-picker
              v-model="formData.cargoReadyDay"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_label_please_select_cargoReadyDay') || '请选择货好时间'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
            "
          >
            <dict-select
              filterable
              v-model="formData.dispatchPort"
              url="/master/port/select"
              size="mini"
              clearable
              :placeholder="
                $l('INDEX.form_placeholder_dispatchPort') || '请选择发运港口'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
            "
          >
            <dict-select
              filterable
              v-model="formData.destinationPort"
              url="/master/port/select"
              size="mini"
              clearable
              :placeholder="
                $l('INDEX.placeholder_destinationPort') || '请选择目的港口'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <BatchTable
        ref="batchTable"
        class="mt-2"
        :tableData="data"
        :errorKeys="errorKeys"
        @delete="(e) => $emit('delete', e)"
      />
    </el-form>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import BatchTable from './table.vue'
export default {
  components: { BatchTable },
  props: {
    data: { type: Array, default: () => [] },
    errorKeys: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        custCode: '',
        custName: '',
        dispatchPort: '',
        plannedETD: '',
        plannedEndETD: '',
        cargoReadyDay: '',
        destinationPort: '',
      },
      rules: {
        plannedETD: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        plannedEndETD: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        cargoReadyDay: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_cargoReadyDay') || '请选择货好时间',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    data: {
      handler(e) {
        if (!e || !e.length) return

        if (this.errorKeys && this.errorKeys.length) return

        const {
          custCode = '',
          custName = '',
          dispatchPort = '',
          shipmentDate = '',
          shipmentEndDate = '',
          cargoReadyDay = '',
          destinationPort = '',
          endCustCode = '',
          endCustName = ''
        } = e[0] || {}

        this.formData.custCode = custCode
        this.formData.custName = custName
        this.formData.dispatchPort = dispatchPort
        this.formData.plannedETD = shipmentDate
        this.formData.plannedEndETD = shipmentEndDate
        this.formData.cargoReadyDay = cargoReadyDay
        this.formData.destinationPort = destinationPort
        this.formData.endCustCode = endCustCode
        this.formData.endCustName = endCustName
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onBatchTableDelete(e) {
      this.$emit('delete', e)
    },
    async getData() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false
      return {
        ...this.formData,
        orderBatchCodeList: this.data.map((row) => row.orderBatchCode),
      }
    },
  },
}
</script>
